// extracted by mini-css-extract-plugin
export default {"banner":"modal_banner__t-A4t","text":"modal_text__iAu68","link":"modal_link__hRagj","button":"modal_button__rlfPh"};